import React from 'react';
import styles from './ProjectsDashboard.module.scss';

import { useProjectsDashboard } from './hooks/UseProjectDashboad';
import Loader from '../../../../Components/Loader/Loader';
import { WorkspaceView } from '../../../../Components/WorkspaceView/WorkspaceView';
import { SFSpinner } from 'sfui';
import { TinyWidgets } from '../../../../Components/TinyWidgets/TinyWidgets';
import { NoProjects } from './NoProjects/NoProjects';
import { ProjectsDashboardHeader } from './ProjectsDashboardHeader/ProjectsDashboardHeader';
import { ProjectsList } from './ProjectsList/ProjectsList';

export interface ProjectsDashboardProps {}

export const ProjectsDashboard = (
  props: ProjectsDashboardProps
): React.ReactElement<ProjectsDashboardProps> => {
  const {
    isLoading,
    isFetchingMoreProjects,
    projects,
    totals,
    tinyWidgetsTotals,
    onScrollBottom,
    refScrollable
  } = useProjectsDashboard({});

  const hasProjects: boolean = projects.length > 0;

  return (
    <div className={styles.projectsDashboard}>
      {isLoading && <Loader />}
      {!isLoading && !hasProjects && <NoProjects />}

      {!isLoading && hasProjects && (
        <>
          <WorkspaceView
            onScrollBottom={onScrollBottom}
            ref={refScrollable}
            header={<ProjectsDashboardHeader />}
          >
            <div className={styles.content}>
              {totals && <TinyWidgets totals={tinyWidgetsTotals} />}

              <ProjectsList projects={projects} />

              {isFetchingMoreProjects && (
                <div className={styles.moreProjectsSpinner}>
                  <SFSpinner size={40} />
                </div>
              )}
            </div>
          </WorkspaceView>
        </>
      )}
    </div>
  );
};
